import React from 'react';
import { PartialMarkData } from '../components/UI/tableCellTypes/MarksArray/MarksArray';
import Translation from '../components/UI/Translation';
/**
 * Klasa umożliwiająca destrukturyzację zagnieżdżonych obiektów oraz konwertowanie obiektów do pożądanych form
 *
 */
class DataDestructuring {
  /** destrukturyzacja ocen cząstkowych */
  public destructurePartialMarks = (partialMarks: any): PartialMarkData[] => {
    if (partialMarks && partialMarks.dane && partialMarks.dane.ocenyCzastkowe && partialMarks.dane.ocenyCzastkowe.ocena) {
      return partialMarks.dane.ocenyCzastkowe.ocena;
    }
    return [];
  };
  /** destrukturyzacja dostępu do ocen cząstkowych */
  public destructurePartialMarksAccess = (partialMarks: any): PartialMarkData[] => {
    if (partialMarks && partialMarks.dane && partialMarks.dane.formy) {
      return partialMarks.dane.formy;
    }
    return [];
  };
  /** destrukturyzacja informacji, czy użytkownik jest kierownikiem formy zajęć */
  public czyKierownik = (data: any[]): boolean => {
    if (data.length && data[0] && data[0].formyZajec) {
      return data[0].formyZajec.czyKierownik;
    }
    return false;
  };
  /** destrukturyzacja informacji, czy użytkownik jest kierownikiem formy zajęć na stronie studenta */
  public czyKierownikStronaStudenta = (subjectData: any): boolean => {
    if (subjectData[0] && subjectData[0].dostep) {
      return subjectData[0].dostep.czyKierownik;
    }
    return false;
  };
  /** budowa parametrów do zapytania o wartości filtrów */
  public returnMultiFilterData = (filter: FilterData): string | false | string[] => {
    if (!filter.selected.length) return false;
    else if (filter.selected.length === 1) return filter.selected[0];
    else return filter.selected;
  };
  /* przygotowanie kolumn jako parametru do zapytania */
  public prepareColumnsAsParam = (cols: string[], mandatoryColumns: string[]): string[] => {
    const columns = [...cols];
    mandatoryColumns.forEach(key => {
      if (!columns.includes(key)) {
        columns.push(key);
      }
    });
    return columns;
  };
  /** zwrócenie informacji o dostępnych wersjach karty przedmiotu */
  public returnAvailableCardVersions = (czy2019: string, czy2020: string): string[] => {
    const versions: string[] = [];
    if (czy2020 === 'T') versions.push('2020');
    if (czy2019 === 'T') versions.push('2019');
    return versions;
  };
  /** dodanie kluczy do danych do tabeli */
  public addKey = (array: any[], key = ''): any[] => {
    return array ? array.map((item, idx) => ({ ...item, key: key.length ? item[key] : idx })) : [];
  };
  /** dodanie numeracji do danych w tabeli */
  public numberData = (data: any[]): any[] =>
    data.map((rec: any, idx: number) => ({
      ...rec,
      lp: idx + 1,
    }));
  /** dodanie translacji do kolumn tabel */
  public addColumnsTranslations = (columns: SingleColumn[]): SingleColumn[] =>
    columns.map((col: SingleColumn) => ({ ...col, title: <Translation id={`${col.title}`} /> }));
  /** wsumowanie wartości z zestawu danych */
  public countTotal = (data: any[], key: string): number => data.reduce((total, item) => item[key] + total, 0);
  /** dodanie kolumny z buttonami akcji dla tabeli readOnly */
  public createReadOnlyColumns = (columns: SingleColumn[]): SingleColumn[] => {
    const readOnlyColumns = [...columns];
    readOnlyColumns.push({
      title: '',
      dataIndex: 'actions',
      width: '10%',
      sorter: false,
    });
    return readOnlyColumns;
  };
}

export default new DataDestructuring();
